import { render, staticRenderFns } from "./FormDetailNaturalQuestions.vue?vue&type=template&id=8e696f12&scoped=true&"
import script from "./FormDetailNaturalQuestions.vue?vue&type=script&lang=js&"
export * from "./FormDetailNaturalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailNaturalQuestions.vue?vue&type=style&index=0&id=8e696f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e696f12",
  null
  
)

export default component.exports